import Vue from 'vue';
import { mapGetters } from 'vuex';
import formatDateMixin from '@/mixins/formatDate';

let filtersList = [
  {
    name: 'delinquency',
    field: 'delinquency',
    title: 'Dias de mora',
    not_fetch: true,
    items: [],
  },
  {
    name: 'first_delinquency',
    field: 'first_delinquency',
    title: 'Primer delinquency',
    not_fetch: true,
    items: [],
  },
  {
    name: 'account_type',
    field: 'account_type_id',
    title: 'Producto',
    items: [],
  },
  {
    name: 'tranche',
    field: 'tranche_id',
    title: 'Tramo de mora',
    items: [],
  },
  {
    name: 'due_day',
    url: 'due_dates',
    field: 'due_day_id',
    title: 'Dia de vencimiento',
    items: [],
  },
  {
    name: 'portfolio_type',
    field: 'portfolio_type_id',
    title: 'Cartera',
    items: [],
  },
  {
    name: 'agency',
    url: 'agencies',
    field: 'agency_id',
    title: 'Agencia',
    items: [],
  },
  {
    name: 'agent',
    field: 'agent_id',
    title: 'Agente',
    items: [],
  },
  {
    name: 'age_group',
    field: 'age_group_id',
    title: 'Grupos de edad',
    items: [],
  },
  {
    name: 'state',
    field: 'state_id',
    title: 'Estado',
    items: [],
  },
  {
    name: 'gender',
    field: 'gender_id',
    title: 'Genero',
    items: [],
  },
  {
    name: 'partial_refinancing',
    field: 'partial_refinancing',
    title: 'Refinanciamiento parcial',
    not_fetch: true,
    items: [
      {
        id: 1,
        name: 'Activo',
      },
      {
        id: 0,
        name: 'Inactivo',
      },
    ],
  },
  {
    name: 'customer_type',
    field: 'customer_type',
    title: 'Tipo de cliente',
    not_fetch: true,
    items: [
      {
        id: 1,
        name: 'Empresa',
      },
      {
        id: 0,
        name: 'Persona natural',
      },
    ],
  },
  {
    name: 'alivia_enabled',
    field: 'alivia_enabled',
    title: 'Alivia',
    not_fetch: true,
    items: [
      {
        id: 1,
        name: 'Activo',
      },
      {
        id: 0,
        name: 'Inactivo',
      },
    ],
  },
  {
    name: 'watchlist',
    field: 'watchlist',
    title: 'Customer Tracking',
    not_fetch: true,
    items: [
      {
        id: 1,
        name: 'Activo',
      },
      {
        id: 0,
        name: 'Inactivo',
      },
    ],
  },
  {
    name: 'week_day',
    field: 'week_day',
    title: 'Dia de la semana',
    not_fetch: true,
    items: [
      {
        id: 1,
        name: 'Lunes',
      },
      {
        id: 2,
        name: 'Martes',
      },
      {
        id: 3,
        name: 'Miercoles',
      },
      {
        id: 4,
        name: 'Jueves',
      },
      {
        id: 5,
        name: 'Viernes',
      },
      {
        id: 6,
        name: 'Sabado',
      },
      {
        id: 7,
        name: 'Domingo',
      },
    ],
  },
  {
    name: 'total_refinancing',
    field: 'total_refinancing',
    title: 'Refinanciamiento total',
    not_fetch: true,
    items: [
      {
        id: 1,
        name: 'Activo',
      },
      {
        id: 0,
        name: 'Inactivo',
      },
    ],
  },
  {
    name: 'calendar_day',
    field: 'calendar_day',
    title: 'Dia calendario',
    not_fetch: true,
  },
  // {
  //   name: 'customer_status',
  //   field: 'customer_status_id',
  //   title: 'Estado del cliente',
  //   items: [],
  //   url: 'customer_status',
  // },
  {
    name: 'broken_promises',
    field: 'broken_promises',
    title: 'Compromisos rotos',
    not_fetch: true,
  },
  {
    name: 'payment_promise',
    field: 'payment_promise',
    title: 'Fecha de compromiso',
    not_fetch: true,
  },
  {
    name: 'last_notification',
    field: 'last_notification',
    title: 'Ultima gestión',
    not_fetch: true,
  },
  {
    title: 'Primer día de carga',
    field: 'first_sync_date',
    name: 'first_sync_date',
    not_fetch: true,
  },
  {
    title: 'Último día de carga',
    field: 'last_sync_date',
    name: 'last_sync_date',
    not_fetch: true,
  },
  {
    title: 'CK',
    field: 'segment_balance',
    name: 'segment_balance',
    not_fetch: true,
    items: [
      {
        id: 1,
        name: 'CK 1',
      },
      {
        id: 2,
        name: 'CK 2',
      },
      {
        id: 3,
        name: 'CK 3',
      },
      {
        id: 4,
        name: 'CK 4',
      },
    ],
  },
  {
    field: 'portfolio_benchmark',
    name: 'portfolio_benchmark',
    title: 'Portfolio Benchmark (text)',
    not_fetch: true,
  },
  {
    field: 'portfolio_benchmark_id',
    name: 'portfolio_benchmarks',
    url: 'portfolio_benchmarks',
    title: 'Portfolio Benchmark (dimensión)',
    items: [],
  },
  {
    name: 'ab_testing_1',
    field: 'ab_testing_1',
    title: 'A/B Testing 1',
    not_fetch: true,
    items: [
      {
        id: 1,
        name: 'Activo',
      },
      {
        id: 0,
        name: 'Inactivo',
      },
    ],
  },
  {
    name: 'ab_testing_2',
    field: 'ab_testing_2',
    title: 'A/B Testing 2',
    not_fetch: true,
    items: [
      {
        id: 1,
        name: 'Activo',
      },
      {
        id: 0,
        name: 'Inactivo',
      },
    ],
  },
  {
    name: 'ab_testing_3',
    field: 'ab_testing_3',
    title: 'A/B Testing 3',
    not_fetch: true,
    items: [
      {
        id: 1,
        name: 'Activo',
      },
      {
        id: 0,
        name: 'Inactivo',
      },
    ],
  },
  {
    name: 'ab_testing_4',
    field: 'ab_testing_4',
    title: 'A/B Testing 4',
    not_fetch: true,
    items: [
      {
        id: 1,
        name: 'Activo',
      },
      {
        id: 0,
        name: 'Inactivo',
      },
    ],
  },
  {
    name: 'best_cs_journey',
    field: 'best_cs_journey',
    title: 'Mejor etapa por canal',
    type: 'channel_journey',
    not_fetch: true,
    tooltip: '<strong>Mejor etapa por canal</strong><br><em>¿Qué mide?</em> La etapa más avanzada que alcanzó el cliente en un canal específico durante el mes.<br><br>Etapas (de menor a mayor):<br>Barrido general → Barrido exitoso → Conexión → Contacto → Contacto directo → Compromiso<br><br><em>General</em> = mejor etapa considerando todos los canales.',
  },
  {
    name: 'first_mgmt_days',
    field: 'first_mgmt_days',
    title: 'Días desde primera gestión',
    type: 'channel_days',
    not_fetch: true,
    tooltip: '<strong>Días desde primera gestión</strong><br><em>¿Qué mide?</em> Cuántos días pasaron desde la primera gestión del cliente en un canal específico este mes.<br><br>-1 = Sin gestión &nbsp;·&nbsp; 0 = Hoy &nbsp;·&nbsp; N = Hace N días<br><br><em>General</em> = primera gestión de cualquier canal.',
  },
  {
    name: 'last_mgmt_days',
    field: 'last_mgmt_days',
    title: 'Días desde última gestión',
    type: 'channel_days',
    not_fetch: true,
    tooltip: '<strong>Días desde última gestión</strong><br><em>¿Qué mide?</em> Cuántos días pasaron desde la última gestión del cliente en un canal específico este mes.<br><br>-1 = Sin gestión &nbsp;·&nbsp; 0 = Hoy &nbsp;·&nbsp; N = Hace N días<br><br><em>General</em> = última gestión de cualquier canal.',
  },
  {
    name: 'first_sync_days',
    field: 'first_sync_days',
    title: 'Días desde que llegó el cliente',
    not_fetch: true,
    tooltip: '<strong>Días desde que llegó el cliente</strong><br><em>¿Qué mide?</em> Cuántos días pasaron desde que el cliente fue cargado por primera vez en la plataforma.<br><br>0 = Llegó hoy &nbsp;·&nbsp; N = Hace N días',
  },
  {
    name: 'payment_intention_days',
    field: 'payment_intention_days',
    title: 'Días hasta su intención de pago',
    not_fetch: true,
    tooltip: '<strong>Días hasta su intención de pago</strong><br><em>¿Qué mide?</em> Cuántos días faltan para la fecha en que el cliente prometió pagar.<br><br>0 = Hoy &nbsp;·&nbsp; N positivo = Faltan N días &nbsp;·&nbsp; N negativo = Promesa ya vencida (p. ej. -1 = venció ayer)<br><br>Sin intención registrada = sin valor (null). Canales que registran: <strong>Bot, Humano</strong>',
  },
];

for (let i = 1; i < 11; i += 1) {
  filtersList.push({
    field: `info_${i}`,
    name: `info_${i}`,
    title: `info_${i}`,
    not_fetch: true,
  });
}

const INITIAL_FILTERS_LIST_LENGTH = filtersList.length;

export function clearWorkflowFiltersCache() {
  for (let i = 0; i < filtersList.length; i += 1) {
    localStorage.removeItem(filtersList[i].name);
  }
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith('dim_')) {
      localStorage.removeItem(key);
    }
  });
  if (filtersList.length > INITIAL_FILTERS_LIST_LENGTH) {
    filtersList.splice(INITIAL_FILTERS_LIST_LENGTH);
  }
  for (let i = 0; i < filtersList.length; i += 1) {
    if (!filtersList[i].not_fetch) {
      filtersList[i].items = [];
    }
  }
}

const amountFields = [
  {
    title: 'Saldo de deuda',
    field: 'due_balance',
  },
  {
    title: 'Saldo facturado',
    field: 'invoiced_balance',
  },
  {
    title: 'Saldo total',
    field: 'total_balance',
  },
  {
    title: 'Saldo capital',
    field: 'principal_balance',
  },
  {
    title: 'Saldo provisionado',
    field: 'provision_balance',
  },
  {
    title: 'Saldo pagado',
    field: 'paid_balance',
  },
  {
    title: 'Saldo del prestamo',
    field: 'loan_amount',
  },
];

export default {
  mixins: [
    formatDateMixin,
  ],
  data() {
    return {
      filtersList,
      amountFields,
      // templateVarsOld: [
      //   ...filtersList.filter(item => (
      //     item.field !== 'partial_refinancing'
      //     && item.field !== 'total_refinancing'
      //     && item.field !== 'calendar_day'
      //     && item.field !== 'customer_status'
      //   )),
      //   ...amountFields,
      // ].map(item => (
      //   `${item.title.toLowerCase().replace(/ /g, '_')}`
      // )),
    };
  },
  computed: {
    ...mapGetters({
      dimentions: 'dimentions',
    }),
    filtersAndAmounts() {
      return [
        ...this.dimentions,
        ...this.filtersList,
        {
          name: 'sub_status',
          field: 'sub_status_id',
          title: 'Sub estatus',
          not_fetch: true,
          items: this.$store.getters.customerSubStatuses,
        },
        {
          name: 'agreement_status',
          field: 'agreement_status_id',
          title: 'Estado de convenio',
          not_fetch: true,
          items: this.$store.getters.agreementStatuses,
        },
        {
          name: 'best_ns',
          field: 'best_ns',
          title: 'Mejor estado por canal',
          not_fetch: true,
          tooltip: '<strong>Mejor estado por canal</strong><br><em>¿Qué mide?</em> El mejor estado de gestión que alcanzó el cliente en un canal específico durante el mes.<br><br><em>¿En qué se diferencia de "Mejor etapa por canal"?</em><br>· <strong>Mejor estado</strong> = filtra por estado específico (más detallado)<br>· <strong>Mejor etapa</strong> = filtra por etapa del funnel (más general)',
        },
        ...this.amountFields,
      ];
    },
    amountFieldsMapped() {
      return this.amountFields.map(item => item.field);
    },
    amountFieldsMappedByName() {
      return this.amountFields.map(item => item.title);
    },
    templateVars() {
      return [
        ...this.filtersList.filter(item => (
          item.field !== 'partial_refinancing'
          && item.field !== 'total_refinancing'
          && item.field !== 'calendar_day'
          && item.field !== 'customer_status'
        )),
        ...this.dimentions,
        ...this.amountFields,
      ]
        .map(item => (`${item.title.toLowerCase().replace(/ /g, '_')}`))
        .concat([
          'moneda',
          'referencia',
          'nombre',
          'apellido',
          'nombre_completo',
          'fecha_envio',
          'monto',
          'cuenta',
          'descripcion',
          'email',
          'telefono',
          'fecha_vencimiento',
          'fecha_compromiso',
          'operador',
          'monto_compromiso',
          'mañana',
        ]);
    },
  },
  methods: {
    findFilters() {
      const unloaded = [];
      for (let i = 0; i < filtersList.length; i += 1) {
        const item = filtersList[i];
        const items = localStorage.getItem(item.name);
        if (items) {
          filtersList[i].items = JSON.parse(items);
        } else if (!item.not_fetch) {
          unloaded.push(item);
        }
      }
      if (!filtersList.filter(item => item.name.includes('dim_')).length) {
        unloaded.push({
          name: 'dim',
        });
      }
      return Promise.all(
        unloaded.map(item => Vue.axios.get(`filters/${item.url || `${item.name}s`}`)
          .then(response => ({
            name: item.name,
            items: response.data,
          }))),
      ).then((values) => {
        for (let i = 0; i < values.length; i += 1) {
          const data = values[i];
          if (data.name === 'dim') {
            for (let b = 0; b < data.items.length; b += 1) {
              localStorage.setItem(data.items[b].name, JSON.stringify(data.items[b].items));
            }
            filtersList = [
              ...filtersList,
              ...data.items.map(item => ({
                ...item,
                not_fetch: true,
              })),
            ];
          } else {
            localStorage.setItem(data.name, JSON.stringify(data.items));
            filtersList.find(item => item.name === data.name).items = data.items;
          }
        }
      }).catch(() => { });
    },
    getFilterTitle(field) {
      return (this.filtersAndAmounts.find(item => item.field === field) || {}).title;
    },
    getFilterTooltip(field) {
      return (this.filtersAndAmounts.find(item => item.field === field) || {}).tooltip || null;
    },
    formatChannelJourneyFilterValue(value) {
      let v = value;
      if (typeof v === 'string') {
        try { v = JSON.parse(v); } catch (e) { return v; }
      }
      if (!v || typeof v !== 'object') return '';
      const { channel_ids: channelIds, channel_id: channelIdLegacy, month, journeys } = v;
      const ids = Array.isArray(channelIds) ? channelIds : (channelIdLegacy != null ? [channelIdLegacy] : []);
      const channelLabel = ids.map((id) => {
        if (id === 0) return 'General';
        const ch = this.$store.getters.channel(id) || {};
        return ch.channel || '';
      }).filter(Boolean).join(', ');
      const monthLabels = {
        0: 'Mes actual', 1: 'Últimos dos meses',
        2: 'Últimos tres meses', 3: 'Últimos cuatro meses',
        4: 'Últimos cinco meses',
      };
      const journeyNames = {
        2: 'Barrido general', 3: 'Barrido exitoso', 4: 'Conexión',
        5: 'Contacto', 6: 'Contacto directo', 7: 'Compromiso',
      };
      return [
        channelLabel,
        monthLabels[month] || month || '',
        (journeys || []).map(j => journeyNames[j] || j).join(', '),
      ].filter(Boolean).join(' · ');
    },
    formatChannelDaysFilterValue(value) {
      let v = value;
      if (typeof v === 'string') {
        try { v = JSON.parse(v); } catch (e) { return v; }
      }
      if (!v || typeof v !== 'object') return '';
      const { channel_ids: channelIds, channel_id: channelIdLegacy, days } = v;
      const ids = Array.isArray(channelIds) ? channelIds : (channelIdLegacy != null ? [channelIdLegacy] : []);
      const channelLabel = ids.map((id) => {
        if (id === 0) return 'General';
        const ch = this.$store.getters.channel(id) || {};
        return ch.channel || '';
      }).filter(Boolean).join(', ');
      return [channelLabel, `${days} días`].filter(Boolean).join(' · ');
    },
    formatBestNsFilterValue(value) {
      let v = value;
      if (typeof v === 'string') {
        try {
          v = JSON.parse(v);
        } catch (e) {
          return v;
        }
      }
      if (!v || typeof v !== 'object') {
        return '';
      }
      const { channel_ids: channelIds, channel_id: channelIdLegacy, months, status_id: statusIdRaw } = v;
      const ids = Array.isArray(channelIds) ? channelIds : (channelIdLegacy != null ? [channelIdLegacy] : []);
      const channelLabel = ids.map((id) => {
        const ch = this.$store.getters.channel(id) || {};
        return ch.channel || '';
      }).filter(Boolean).join(', ');
      let statusIds = [];
      if (Array.isArray(statusIdRaw)) {
        statusIds = statusIdRaw;
      } else if (statusIdRaw != null && statusIdRaw !== '') {
        statusIds = [statusIdRaw];
      }
      const statusLabels = statusIds.map((id) => {
        const st = this.$store.getters.status(id) || {};
        return st.status || '';
      }).filter(Boolean);
      const statusLabel = statusLabels.join(', ');
      const monthLabels = {
        0: 'Mes actual',
        1: 'Últimos dos meses',
        2: 'Últimos tres meses',
        3: 'Últimos cuatro meses',
        4: 'Últimos cinco meses',
      };
      const timeLabel = monthLabels[months] != null ? monthLabels[months] : months;
      return [channelLabel, timeLabel, statusLabel].filter(part => part !== '' && part != null).join(' · ');
    },
    getFilterValue(field, value) {
      if (field === 'best_ns') {
        return this.formatBestNsFilterValue(value);
      }
      if (field === 'best_cs_journey') {
        return this.formatChannelJourneyFilterValue(value);
      }
      if (field === 'first_mgmt_days' || field === 'last_mgmt_days') {
        return this.formatChannelDaysFilterValue(value);
      }
      const filter = this.filtersAndAmounts.find(item => item.field === field) || {};
      if (filter.items && filter.items.length > 0) {
        return (filter.items.find(item => item.id === value) || {}).name;
      }
      return value;
    },
    getfilterAndAmountTitle(field) {
      return (this.filtersAndAmounts.find(item => item.field === field) || {}).title;
    },
    checkIfFieldIsAmount(field) {
      return this.amountFieldsMapped.includes(field);
    },
    parseFilterValue(field, value) {
      let result;
      if (field === 'best_ns') {
        return this.formatBestNsFilterValue(value);
      }
      if (field === 'best_cs_journey') {
        return this.formatChannelJourneyFilterValue(value);
      }
      if (field === 'first_mgmt_days' || field === 'last_mgmt_days') {
        return this.formatChannelDaysFilterValue(value);
      }
      if (this.checkIfFieldIsAmount(field)) {
        result = new Intl.NumberFormat('es-VE').format(value);
      } else if (
        field.includes('info_')
        || field === 'delinquency'
        || field === 'first_delinquency'
        || field === 'calendar_day'
        || field === 'broken_promises'
        || field === 'payment_promise'
        || field === 'last_notification'
        || field === 'portfolio_benchmark'
        || field === 'first_sync_days'
        || field === 'payment_intention_days'
      ) {
        result = value;
      } else if (field.includes('_sync_date')) {
        result = this.formatDate(value, 'YYYY-MM-DD', 'DD/MM/YYYY');
      } else {
        result = this.getFilterValue(field, value);
      }
      return result;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/workflowFilters.js